import { render } from "./component-ccy.vue?vue&type=template&id=b0b24fe2"
import script from "./component-ccy.vue?vue&type=script&lang=js"
export * from "./component-ccy.vue?vue&type=script&lang=js"

import "./component-ccy.vue?vue&type=style&index=0&id=b0b24fe2&lang=scss"

import exportComponent from "/Users/admin/Desktop/Project/jy-dashboard-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__